import CategoryDetailAdvancedSeoCategoriesSlider from './CategoryDetailAdvancedSeoCategoriesSlider/CategoryDetailAdvancedSeoCategoriesSlider';
import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import Heading from 'components/Basic/Heading/Heading';
import { useTypedTranslationFunction } from 'hooks/typescript/UseTypedTranslationFunction';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import { twJoin } from 'tailwind-merge';
import { ReadyCategorySeoMixLink } from 'types/category';

type Props = {
    readyCategorySeoMixLinks: ReadyCategorySeoMixLink[];
};

export const categoryDetailAdvancedSeoCategoriesItemTwClass = (): string =>
    twJoin(
        'p-3 flex items-center justify-center rounded-lg bg-grayVeryLight text-center text-small leading-6 text-primary no-underline lg:mr-6 lg:mb-3',
        'hover:bg-blueVeryLight hover:text-primary hover:no-underline active:bg-blueVeryLight active:text-primary active:no-underline',
    );

const CategoryDetailAdvancedSeoCategories: FC<Props> = ({ readyCategorySeoMixLinks }) => {
    const t = useTypedTranslationFunction();

    const isDesktop = useMediaMin('lg');

    if (readyCategorySeoMixLinks.length === 0) {
        return null;
    }

    return (
        <>
            <Heading type="h2">{t('Favorite categories')}</Heading>
            {isDesktop ? (
                <div className="-mr-6 mb-2 flex flex-row flex-wrap">
                    {readyCategorySeoMixLinks.map((seoMixLink, index) => (
                        <ExtendedNextLink
                            key={index}
                            href={`/${seoMixLink.slug}`}
                            className={categoryDetailAdvancedSeoCategoriesItemTwClass()}
                            type="category"
                        >
                            {seoMixLink.name}
                        </ExtendedNextLink>
                    ))}
                </div>
            ) : (
                <CategoryDetailAdvancedSeoCategoriesSlider readyCategorySeoMixLinks={readyCategorySeoMixLinks} />
            )}
        </>
    );
};

export default CategoryDetailAdvancedSeoCategories;
